import React from 'react'

function Gallery({images}) {
    return (
        <div className="gallery">
            {images.map((image, j) => {
                    return <div key={j} className="image-containter">
                        <img src={image.source} alt={image.alt} />
                        
                    </div>
                    })}
        </div>
    )
}

export default Gallery
